import { render, staticRenderFns } from "./Browse.vue?vue&type=template&id=413468c8&scoped=true&"
import script from "./Browse.vue?vue&type=script&lang=js&"
export * from "./Browse.vue?vue&type=script&lang=js&"
import style0 from "./Browse.vue?vue&type=style&index=0&id=413468c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413468c8",
  null
  
)

export default component.exports